// initial state of product is declared here
const initialState = [];

export default initialState;